import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Angular2CsvComponent } from "angular2-csv";
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2'

/**
 * Service files
 */
import { DonationListService } from "../../../services/donation/donationList/donation-list.service"
import { GetOfferingTypeService } from "../../../services/receipts/getOfferingType/get-offering-type.service"
import { SearchEventService } from "../../../services/search/searchEvent/search-event.service";
import { ModeService } from "../../../services/search/getMode/mode.service";
import { GetBankService } from "../../../services/receipts/getBank/get-bank.service"
import { OfferingTypeEventBasedService } from "../../../services/search/offeringTypeEventBased/offering-type-event-based.service";
import { ModeAndMediumService } from "../../../services/receipts/modeAndMedium/mode-and-medium.service";
import { GetOfferingStatusService } from "../../../services/donation/getOfferingStatus/get-offering-status.service";
import { DownloadDonationService } from "../../../services/donation/downloadDonation/download-donation.service";

import { DatepickerOptions } from 'ng2-datepicker';

declare var $: any
@Component({
  selector: 'app-donation-list',
  templateUrl: './donation-list.component.html',
  styleUrls: ['./donation-list.component.less']
})
export class DonationListComponent implements OnInit {
  @HostListener("window:scroll", [])
  onWindowScroll() {
    var bodypos = document.documentElement.scrollHeight || document.body.scrollHeight;
    var windowh = document.documentElement.clientHeight || document.body.clientHeight;
    bodypos = bodypos - windowh;
    var windowpos = document.documentElement.scrollTop || document.body.scrollTop;;
    var persentage = Math.round((windowpos / bodypos) * 100);
    console.log(this.NextCall)
    if (
      Math.round(persentage) > 95 &&
      this.NextCall == 1 &&
      this.search.search_column == "" &&
      this.query.isActive == false
    ) {
      this.StartRecord = +this.StartRecord + +this.lengthOfRecord
      console.log(this.StartRecord)
      this.dqloader = true;
      this.getAllDonationList(this.StartRecord, this.lengthOfRecord);
      this.NextCall = 0;
    }

  }
  @ViewChild(Angular2CsvComponent, null) csvComponent: Angular2CsvComponent;

  @ViewChild('filterData', { static: false }) filterData: NgForm;

  options: any = {}
  data: any = []

  public StartRecord: number = 0
  public lengthOfRecord: number = 10
  public NextCall: any;
  public dqloader: Boolean = false;
  public skeletonLoader: Boolean = true;
  public allDonationDate: any = []
  public filterKey: any = []
  public details: any = []
  public verifyDonation: any

  public order: any = {
    order_column: "",
    order_direct: "desc"
  }

  public query: any = {
    fromDate: null,
    toDate: null,
    offerType: 0,
    bank: 0,
    mode: 0,
    amtGreater: 0,
    amtLesser: 0,
    receiptEvent: 0,
    offeringTypeEventBased: 0,
    status: 0,
    isActive: false
  }

  public toSearch: Boolean = false


  /** filter variable and loader var */
  public offeringTypeData: any
  public bankData: any
  public eventList: any
  public modeData: any
  public offeringTypeEventBasedData: any
  public modeAndMediumData: any
  private offeringStatusData: any

  public eventBasedOfferingType: Boolean = false
  public modeBasedSearch: Boolean = false

  public offeringTypeSkeleton = true
  public selectEventSkeleton = true
  public modeSkeleton = true
  public bankSkeleton = true
  public selectReceiptEventSkeleton = true
  public offeringTypeEventBasedSkeleton: Boolean = true
  public selectOfferingStatusSkeleton: Boolean = true
  public modeBasedSkeleton: Boolean = true
  public submitLoading: Boolean = false
  public exportButtonLoading: Boolean = false
  public fileName: any


  public search: any = {
    search: "",
    search_column: ""
  }


  /**
* For Date picker options
*/
  datePickerOptions: DatepickerOptions = {
    minYear: 1970,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday 
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  constructor(
    private DonationListService: DonationListService,
    private GetOfferingTypeService: GetOfferingTypeService,
    private SearchEventService: SearchEventService,
    private ModeService: ModeService,
    private OfferingTypeEventBasedService: OfferingTypeEventBasedService,
    private ModeAndMediumService: ModeAndMediumService,
    private GetBankService: GetBankService,
    private GetOfferingStatusService: GetOfferingStatusService,
    private DownloadDonationService: DownloadDonationService
  ) { }

  async ngOnInit() {
    await this.getAllDonationList(0, this.lengthOfRecord)
    this.skeletonLoader = false
    setTimeout(function () {
      $(`.searchColumn`).selectpicker('refresh');
    }, 100)
  }

  async getAllDonationList(start, length) {
    this.dqloader = true;
    let response: any = await this.DonationListService.getAllList(
      this.search,
      start,
      length,
      this.order,
      this.query
    );
    console.log(response.data)
    if (response.data.length != 0) {
      response.data.forEach(element => {
        this.allDonationDate.push(element);
      });
      this.exportToCSVOptions()
      this.NextCall = 1;
      this.dqloader = false;
    } else {
      this.NextCall = 0;
      this.dqloader = false;
    }
  }

  async getTotalLength(value) {
    console.log(value)
    this.lengthOfRecord = value
    //  this.getAllReceipts(this.StartRecord,this.lengthOfRecord)
  }


  async getSearchColumn(ele) {
    console.log(ele)
    if (ele != "") {
      this.toSearch = true
      this.search.search_column = ele
      $('#search').val('');
    } else {
      this.toSearch = false
    }
  }

  async searchBy() {
    this.search.search = $("#search").val()
    this.allDonationDate = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
    this.NextCall = 0
  }

  async cancelSearch() {
    this.toSearch = false
    this.search.search_column = ""
    this.search.search = ""
    $(".searchColumn").empty();
    setTimeout(function () {
      $(`.searchColumn`).selectpicker('refresh');
    }, 100)
    this.allDonationDate = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
  }

  async viewDetails(data) {
    $("#donationDetails").modal("show");
    this.details = data
  }

  async VerifyDonation(data) {
    $("#verifyDonation").modal("show");
    this.verifyDonation = data
  }

  async DownloadDonation(offering_id,partner_id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want download...!",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, download it!'
    }).then(async (result) => {

      if (result.value) {
        let result = await this.DownloadDonationService.download(offering_id,partner_id)
        if (result.status == "success") {
          Swal.fire(
            'Downloaded!',
            'Downloaded successfully...!',
            'success'
          )
        }else{
          Swal.fire(
            'Download!',
            'Download Failed...!',
            'warning'
          )
        }
      }
    })
  }

  async outToParent(e) {
    if (e == 'success') {
      // this.isPrint = false 
      this.allDonationDate = []
      this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
    }
  }


  async filterWithDetails(ele) {
    this.submitLoading = true
    // $("[data-id='SearchColumn']").prop('disabled', true);
    this.query = {
      fromDate: ele.fromDate == null ? null : moment(ele.fromDate).format("YYYY-MM-DD"),
      toDate: ele.toDate == null ? null : moment(ele.toDate).format("YYYY-MM-DD"),
      offerType: ele.offeringType == "" ? 0 : ele.offeringType.toString(),
      bank: ele.bank == "" ? 0 : ele.bank.toString(),
      mode: ele.mode == "" ? 0 : parseInt(ele.mode),
      modeAndMedium: ele.modeAndMedium == "" ? 0 : parseInt(ele.modeAndMedium),
      amtGreater: ele.amtGreater == "" ? 0 : parseInt(ele.amtGreater),
      amtLesser: ele.amtLesser == "" ? 0 : parseInt(ele.amtLesser),
      receiptEvent: ele.receiptEvent == "" ? 0 : parseInt(ele.receiptEvent),
      offeringTypeEventBased: ele.offeringTypeEventBased == undefined ? 0 : parseInt(ele.offeringTypeEventBased),
      status: ele.offeringStatus == "" ? 0 : ele.offeringStatus.toString(),
      isActive:true
    }

    // this.search.search_column = "status"
    // this.search.search = ele.offeringStatus

    this.allDonationDate = []
    this.StartRecord = null
    this.lengthOfRecord = null
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
    this.submitLoading = false
  }


  async exportToCSVOptions() {
    let today = new Date();
    this.fileName = "BPM_Donation_List" + today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '_' + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();;
    this.options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: ["Partner Id", "Full Name", "Email Id", "Primary Mobile Number", "Gateway Message", "Created Date", "Gateway Return Status", "Is Verified", "Offering Req Id", "Online Offering Status Name", "Prayer Request", "Receipt Id", "Total Amount", "Transaction Id"],
      showTitle: false,
      title: 'BPM Contacts',
      useBom: false,
      removeNewLines: true,
      keys: ["partner_id", "FULL_NAME", "EMAIL_ID", "PRIMARY_MOBILE_NO", "gateway_message", "created_date", "gateway_return_status", "is_verified", "offering_req_id", "online_offering_status_name", "prayer_request", "receipt_id", "total_amt", "transaction_id"]
    };
    this.data = this.allDonationDate
  }


  async exportToCSV() {
    this.exportButtonLoading = true
    setTimeout(() => {
      this.csvComponent.onDownload();
      this.exportButtonLoading = false
    }, 1000)
  }

  async openSideFilter() {
    document.getElementById("mySidebar").style.width = "300px";
    document.getElementById("main").style.marginRight = "250px";

    await this.getOfferingType()
    await this.getEventLists()
    await this.getMode()
    await this.getBank()
    await this.OfferingStatus()
    let root = this
    setTimeout(function () {
      root.offeringTypeSkeleton = false
      root.selectEventSkeleton = false
      root.modeSkeleton = false
      root.selectReceiptEventSkeleton = false
      root.bankSkeleton = false
      root.selectOfferingStatusSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.offeringType`).selectpicker('refresh');
      $(`.event`).selectpicker('refresh');
      $(`.mode`).selectpicker('refresh');
      $(`.bank`).selectpicker('refresh');
      $(`.offeringStatus`).selectpicker('refresh');
    }, 100)

  }


  async getBank() {
    let data = await this.GetBankService.GetBank()
    this.bankData = data.data
  }

  async getOfferingType() {
    let data = await this.GetOfferingTypeService.GetOfferingType()
    this.offeringTypeData = data.data
  }

  async getEventLists() {
    let event = await this.SearchEventService.getEventList()
    this.eventList = event.data
  }

  async getMode() {
    let data = await this.ModeService.getMode()
    this.modeData = data.data
  }

  async GetModeAndMedium(value) {
    if (value != "") {
      this.modeBasedSearch = true
      this.modeBasedSkeleton = true
      await this.modeBasedSelectionBoxRefresh(value)
    } else {
      this.modeBasedSearch = false
    }
  }

  async modeBasedSelectionBoxRefresh(id) {
    await this.getModeAndMedium(id)
    let root = this
    setTimeout(function () {
      root.modeBasedSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.modeAndMedium`).selectpicker('refresh');
    }, 100)
  }

  async getModeAndMedium(id) {
    let data = await this.ModeAndMediumService.GetModeAndMedium(id)
    this.modeAndMediumData = data.data
  }

  async getEventId(value) {
    if (value != "") {
      this.eventBasedOfferingType = true
      this.offeringTypeEventBasedSkeleton = true
      await this.offeringTypeEventBasedSelectionBoxRefresh()
    } else {
      this.eventBasedOfferingType = false
    }
  }

  async offeringTypeEventBasedSelectionBoxRefresh() {
    await this.getOfferingTypeEventBased()
    let root = this
    setTimeout(function () {
      root.offeringTypeEventBasedSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.offeringTypeEventBased`).selectpicker('refresh');
    }, 100)
  }

  async getOfferingTypeEventBased() {
    let data = await this.OfferingTypeEventBasedService.getOfferingTypeEvent()
    this.offeringTypeEventBasedData = data.data
  }

  async OfferingStatus() {
    let data = await this.GetOfferingStatusService.getOfferingStatus()
    this.offeringStatusData = data.data
    console.log(this.offeringStatusData)
  }



  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      event.preventDefault();
    }
  }

  async closeSideFilter() {
    //   setTimeout(function () {
    //   $("[data-id='SearchColumn']").prop('disabled', false);
    //   $(`.searchColumn`).selectpicker('refresh');
    // }, 100)
    this.query = {
      fromDate: null,
      toDate: null,
      offerType: 0,
      bank: 0,
      mode: 0,
      amtGreater: 0,
      amtLesser: 0,
      receiptEvent: 0,
      offeringTypeEventBased: 0,
      status:0,
      isActive: false
    }
    this.filterData.resetForm();

    this.allDonationDate = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)

    this.modeBasedSearch = false
    this.eventBasedOfferingType = false
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
  }

  async moveRight() {
    event.preventDefault();
    $(".table-responsive").animate(
      {
        scrollLeft: "+=1000px"
      },
      "slow"
    );
  }

  async moveLeft() {
    event.preventDefault();
    $(".table-responsive").animate(
      {
        scrollLeft: "-=1000px"
      },
      "slow"
    );
  }

}
